export const groupServicesByType = (refundServices) => {
    const servicesByType = new Map();
    refundServices === null || refundServices === void 0 ? void 0 : refundServices.forEach(refundService => {
        var _a;
        const serviceType = (_a = refundService === null || refundService === void 0 ? void 0 : refundService.service) === null || _a === void 0 ? void 0 : _a.type;
        servicesByType.set(serviceType, [
            ...(servicesByType.has(serviceType) ? servicesByType.get(serviceType) : []),
            refundService
        ]);
    });
    return servicesByType;
};
export const groupRefundServicesByPassenger = (refundServices) => {
    const serviceByPassenger = {};
    refundServices === null || refundServices === void 0 ? void 0 : refundServices.forEach(gdsInfo => {
        const service = gdsInfo.service;
        gdsInfo.gdsServiceProductsRefundInfo.forEach(product => {
            setProductToGroup(serviceByPassenger, product, service);
        });
    });
    return serviceByPassenger;
};
const setProductToGroup = (group, product, service) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const passengerId = product.product.passengerId, emdNumber = product.product.emdNumber;
    if (group.hasOwnProperty(passengerId)) {
        group[passengerId] = Object.assign(Object.assign({}, group[passengerId]), { [emdNumber]: {
                services: Object.assign(Object.assign({}, (((_a = group[passengerId][emdNumber]) === null || _a === void 0 ? void 0 : _a.services) || {})), { [service.id]: {
                        service: service,
                        products: [...(((_d = (_c = (_b = group[passengerId][emdNumber]) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c[service.id]) === null || _d === void 0 ? void 0 : _d.products) || []), product],
                        sumToRefund: {
                            amount: (((_h = (_g = (_f = (_e = group[passengerId][emdNumber]) === null || _e === void 0 ? void 0 : _e.services) === null || _f === void 0 ? void 0 : _f[service.id]) === null || _g === void 0 ? void 0 : _g.sumToRefund) === null || _h === void 0 ? void 0 : _h.amount) || 0) +
                                ((_j = product.sumToRefund) === null || _j === void 0 ? void 0 : _j.amount),
                            currency: (_k = product.sumToRefund) === null || _k === void 0 ? void 0 : _k.currency
                        }
                    } })
            } });
    }
    else {
        group[passengerId] = {
            [emdNumber]: {
                services: {
                    [service.id]: {
                        service,
                        products: [product],
                        sumToRefund: product.sumToRefund
                    }
                }
            }
        };
    }
};
export const getProductsToExchange = (services, segmentIds = []) => {
    const emdMap = new Map();
    const productIdsByEmd = new Map();
    const productIds = [];
    services.forEach(service => {
        const isMatchBySegments = !segmentIds.length || segmentIds.find(segmentId => service.segmentIds.includes(segmentId));
        service.products.forEach(product => {
            if (product.emdNumber) {
                productIdsByEmd.set(product.emdNumber, [
                    ...(productIdsByEmd.get(product.emdNumber) || []),
                    parseInt(product.id)
                ]);
                if (isMatchBySegments) {
                    service.products.forEach(product => {
                        emdMap.set(product.emdNumber, product.emdNumber);
                    });
                }
            }
        });
    });
    emdMap.forEach(emd => {
        if (productIdsByEmd.has(emd)) {
            productIds.push(...productIdsByEmd.get(emd));
        }
    });
    return [...new Set(productIds)];
};
export const flattenAllowedSegments = (allowedSegments) => {
    const segmentIds = new Set();
    allowedSegments === null || allowedSegments === void 0 ? void 0 : allowedSegments.forEach(group => group === null || group === void 0 ? void 0 : group.forEach(segmentId => segmentId && segmentIds.add(segmentId)));
    return [...segmentIds];
};
export const getPassengersSelectedProductIds = (travellers, passengerIds, segmentIds, isAllFlightToExchange) => {
    const services = [];
    passengerIds.forEach(passengerId => {
        var _a, _b, _c, _d, _e;
        const traveller = travellers.find(traveller => traveller.id === passengerId);
        if ((_b = (_a = traveller === null || traveller === void 0 ? void 0 : traveller.services) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) {
            services.push(...(_d = (_c = traveller === null || traveller === void 0 ? void 0 : traveller.services) === null || _c === void 0 ? void 0 : _c.gdsServices) === null || _d === void 0 ? void 0 : _d.services);
        }
        if ((_e = traveller === null || traveller === void 0 ? void 0 : traveller.services) === null || _e === void 0 ? void 0 : _e.seats) {
            traveller.services.seats.forEach(seat => {
                if (!seat.product) {
                    return;
                }
                services.push({
                    segmentIds: [seat.segment.id],
                    products: [seat.product]
                });
            });
        }
    });
    return getProductsToExchange(services, isAllFlightToExchange ? [] : segmentIds);
};
